  <section class="content_top_margin" aria-live="assertive" role="alert">
    <ng-container *ngIf="!referral">
      <ng-container *ngIf="requestPreQual.flow_type==prequalType">
        <ng-container *ngIf="timoutIssue">
          <span class="sectionHeadingMain ">{{'requestcallpage.errTitle'|translate}}</span>
        </ng-container>
        <ng-container *ngIf="!timoutIssue">
          <span class="sectionHeadingMain ">{{'requestcallpage.requestMessagePrequal'|translate}}</span>
        </ng-container>
        <p class="mb-0 top_spa_aft_sect_heading">{{'requestcallpage.requestMessagePrequalAdvice'|translate}}</p>
      </ng-container>

      <ng-container *ngIf="requestPreQual.flow_type==switchType">
        <ng-container *ngIf="creditBureauError">
          <span class="sectionHeadingMain ">{{'requestcallpage.requestMessagedigitalswitch'|translate}}</span>
        </ng-container>
        <ng-container *ngIf="timoutIssue">
          <span class="sectionHeadingMain ">{{'requestcallpage.errTitle'|translate}}</span>
        </ng-container>
        <ng-container *ngIf="genericIssue">
          <span class="sectionHeadingMain ">{{'requestcallpage.requestMessagedigitalswitch'|translate}}</span>
        </ng-container>
        <p class="mb-0 top_spa_aft_sect_heading">{{'requestcallpage.requestMessagedigitalswitchAdvice'|translate}}</p>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="referral&&maObjPresent">
      <ng-container *ngIf="isReferralMaPresent">
        <span class="sectionHeadingMain " *ngIf="requestPreQual.flow_type==prequalType" [innerHTML]="'requestcallpage.referralWithNoMaPrequal'|translate:{ma_advisor:maObj.firstname,ma_phone:maObj.phone_number|
          mask: '000-000-0000',ma_mail:maObj.email}">
        </span>
        <span class="sectionHeadingMain " *ngIf="requestPreQual.flow_type==switchType" [innerHTML]="'requestcallpage.referralWithNoMaSwitch'|translate:{ma_advisor:maObj.firstname,ma_phone:maObj.phone_number|
          mask: '000-000-0000',ma_mail:maObj.email}">
        </span>
      </ng-container>
      <ng-container *ngIf="!isReferralMaPresent">

        <span class="sectionHeadingMain">
          <ng-container *ngIf="requestPreQual.flow_type==prequalType">
            {{'requestcallpage.referralWithNoMa2'|translate}}
          </ng-container>
          <ng-container *ngIf="requestPreQual.flow_type==switchType">
            {{'requestcallpage.referralWithNoMa2Switch'|translate}}
          </ng-container>
        </span>
        <p class="mb-0 top_spa_aft_sect_heading">
          {{'requestcallpage.referralWithNoma3'|translate}}
          <span class="underLineLanding" (click)="onRequestCall()">
            {{'requestcallpage.referralWithNoma4'|translate}}
          </span>
          <ng-container *ngIf="requestPreQual.flow_type==prequalType">
            {{'requestcallpage.referralWithNoma5'|translate}}
          </ng-container>
          <ng-container *ngIf="requestPreQual.flow_type==switchType">
            {{'requestcallpage.referralWithNoMa3Switch'|translate}}
          </ng-container>
        </p>
      </ng-container>
    </ng-container>
  </section>
  <div class="row no-gutters top_height_actionButton content_top_mobile_margin" *ngIf="!isReferralMaPresent||!referral">
    <div class="col-12 d-flex d-md-block flex-column-reverse">
      <cancel-button></cancel-button>
      <button type="button" class="common_btn saveNextBtn_features space_between_button" (click)="onRequestCall()">
        <ng-container *ngIf="!referral">
          {{'requestcallpage.requestcallbuttontitle'| translate}}
        </ng-container>
        <ng-container *ngIf="referral&&!isReferralMaPresent">
          {{'popupMessages.findMortgageAdvisor'| translate}}
        </ng-container>
        <span class="show-for-sr">
          {{'footer.titlePrivacyPolicy' | translate}}
        </span> </button>
    </div>
  </div>

<div class="modal fade" id="submitMsgPopup" role="dialog" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-lg">
    <div class="modal-content msgModalContent">
      <div class="modal-header msgModalHeader">
        <button type="button" class="close" data-dismiss="modal" data-toggle="tooltip" data-placement="top">&times;
          <span class="show-for-sr">{{'requestcallpage.close' | translate}}</span>

        </button>
      </div>
      <div class="modal-body msgModalBody">
        {{ 'requestcallpage.thanksMsg' | translate }}
      </div>
      <div class="modal-footer">
        <button type="button" class="btn buttonCommon saveNextBtn" data-dismiss="modal" (click)="goTo()">
          {{ 'requestcallpage.Ok' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>